module.exports = __webpack_public_path__ + "static/img/broadcast_banner.ca78bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast_banner.png
// module id = kkRM
// module chunks = 0